import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AppstoreOutlinedSvg from "@ant-design/icons-svg/es/asn/AppstoreOutlined";
import AntdIcon from "../components/AntdIcon";
var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AppstoreOutlined.displayName = 'AppstoreOutlined';
}
export default /*#__PURE__*/React.forwardRef(AppstoreOutlined);